import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/header-img.svg";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import resume from "../Akshay_Gaurav_Resume.pdf";
//import { Link, Text } from "@chakra-ui/react";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "A Full-Stack Web Developer", "A MERN Developer", "An Explorer" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <h1 id="user-detail-name" >{`Hi! I'm Akshay Kumar Gaurav,`} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "A Full-Stack Web Developer", "A MERN Developer", "An Explorer" ]'><span className="wrap">{text}</span></span></h1>
                  <p  id="user-detail-intro">An enthusiastic Full Stack Web Developer, a lifelong learner, skilled in frontend and back-end Web Development. 
                    Knowledge of HTML, CSS, Python, JavaScript, ReactJs, MongoDB, Express and NodeJs. High adaptability to learn new technologies quickly and paying attention to details.
                     Aims to leverage knowledge and build worldclass websites while facilitating organization in achieving functional goals.</p>
                  <button id="resume-button-2" onClick={() => window.open("https://drive.google.com/file/d/1ekChql2uokFwbp5jUYriDAvMOYX1Orm-/view?usp=sharing")}> 
                  <a
                        id="resume-link-2"
                        href={resume}  
                        download="Akshay_Gaurav_Resume.pdf"
                        style={{
                          textDecoration: "none",
                          color: "white ",
                          border: "2px dotted yellow",
                          padding:"10px 10px",
                          borderRadius:"10px"
                          
                        }}
                      >
                        Akshay's Resume <ArrowRightCircle size={25} />
                      </a></button>
                  {/* <HashLink to='https://drive.google.com/file/d/1ekChql2uokFwbp5jUYriDAvMOYX1Orm-/view?usp=sharing' >
                <button 
                 className="vvd"  id="resume-button-1" class="nav-link resume" onClick={() => window.open("https://drive.google.com/file/d/1ekChql2uokFwbp5jUYriDAvMOYX1Orm-/view?usp=sharing")}>
                    <a 
                        
                        href={resume}
                        download="Akshay_Gaurav_Resume.pdf"
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                        }}
                      >
                        Resume
                      </a></button>
              </HashLink> */}
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}